import React from "react";
import {
  DollarSign,
  CreditCard,
  PieChart,
  Shield,
  TrendingUp,
  Wallet,
  Building,
  LineChart,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Digital Banking Solutions",
    description:
      "Build modern banking apps with seamless account management and transactions",
    icon: Building,
  },
  {
    title: "Payment Gateway Integration",
    description:
      "Implement secure payment processing with multiple gateway support",
    icon: CreditCard,
  },
  {
    title: "Investment Platforms",
    description:
      "Create trading apps, robo-advisors, and portfolio management systems",
    icon: TrendingUp,
  },
  {
    title: "Lending & Credit Systems",
    description:
      "Develop loan origination, credit scoring, and underwriting platforms",
    icon: DollarSign,
  },
  {
    title: "Regulatory Compliance",
    description: "Ensure PCI-DSS, SOC2, and financial regulatory compliance",
    icon: Shield,
  },
  {
    title: "Financial Analytics",
    description:
      "Build real-time dashboards for financial reporting and insights",
    icon: PieChart,
  },
  {
    title: "Blockchain Solutions",
    description:
      "Implement DeFi, smart contracts, and cryptocurrency integrations",
    icon: Wallet,
  },
  {
    title: "Risk Management",
    description: "AI-powered fraud detection and risk assessment systems",
    icon: LineChart,
  },
];

const STATS = [
  { value: "$2B+", label: "Transactions" },
  { value: "80+", label: "FinTech Apps" },
  { value: "PCI-DSS", label: "Compliant" },
  { value: "99.99%", label: "Uptime" },
];

const FinanceIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="fintech-finance"
      industryTitle="FinTech"
      industrySubtitle="& Finance"
      heroDescription="Building secure, scalable financial technology solutions that transform banking, payments, and investment management with cutting-edge security and compliance."
      themeColor="#10b981"
      themeColorLight="#34d399"
      themeGradient="linear-gradient(135deg, #064e3b 0%, #047857 50%, #10b981 100%)"
      HeroIcon={DollarSign}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1559526324-593bc073d938?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default FinanceIndustryPage;
